import CarIcons from 'components/icons/landing/car-icons';
import Label from '../labels/labels';
import PropTypes from 'prop-types';
import RightChevronIcon from 'components/icons/landing/right-chevron-icon';
import styles from 'styles/LandingComponents.module.scss';
import TableFonts from '../labels/table-fonts';
import useRichTranslation from 'hooks/useRichTranslation';
import { useTranslations } from 'next-intl';

const ChangeCarLocationBanner = ({ enableFrame, carName }) => {
    const t = useTranslations('banners.edit-vehicle-banner');
    const tRich = useRichTranslation('banners.edit-vehicle-banner');
    const title = tRich('available-insurances');
    return (
        <div
            className={`
    ${styles.landing__banner_wrapper}
    ${enableFrame ? styles.landing__banner_frame : ''}
    `}
            style={{ alignItems: 'center' }}
        >
            <div className={styles.banner__label}>
                <Label
                    size={18}
                    color="pink"
                    boldColor="pink"
                    transform="uppercase"
                    boldTransform="uppercase"
                >
                    {title}
                </Label>
            </div>
            <div className={styles.banner__car_label}>
                <CarIcons width={70} icon="medium_car" fill="#000" />
                <div style={{ width: '80%', marginLeft: 5 }}>
                    <TableFonts textTransform="uppercase">
                        <span>{t('car')}</span>
                    </TableFonts>
                    <TableFonts type="body-big" textTransform="capitalize">
                        {carName}
                    </TableFonts>
                </div>
            </div>
            <a className={styles.landing__button_wrapper} href={t('link')}>
                <TableFonts
                    color="white"
                    type="button"
                    textTransform="uppercase"
                >
                    {t('button-title')}
                </TableFonts>
                <div style={{ marginLeft: 10 }}>
                    <RightChevronIcon />
                </div>
            </a>
        </div>
    );
};

ChangeCarLocationBanner.propTypes = {
    enableFrame: PropTypes.bool,
    carName: PropTypes.string
};

export default ChangeCarLocationBanner;
